// schemas
import { TemplateForms } from "./index";

// in order to check if the user has unsaved changes, we need to compare the localTemplateForms to the templateForms without the isEditing property (since isEditing does not always indicate changes were made)
export const getFormsExcludingIsEditing = (formsObject: TemplateForms) => {
	const formTypes = ["basicForms", "externalForms", "easyAddForms"];

	const filteredFormTypes = formTypes.reduce((acc, formType) => {
		const filtered = formsObject[formType].map((form) => {
			const { isEditing, ...other } = form;
			return other;
		});
		acc[formType] = filtered;
		return acc;
	}, {});

	return filteredFormTypes;
};

const getWhoCanAdd = (whoCanAddObj, subjectEmployeeChooseAuthor) => {
	let whoCanAdd = "";
	const whoCanAddKeys = Object.keys(whoCanAddObj);
	whoCanAddKeys.forEach((item) => {
		if (whoCanAddObj[item] === true) {
			whoCanAdd = item;
		}
	});
	// If "Who can add this form" is "Subject" then there is an additional
	// field "subject type" to specify how to determine the author - "self" for
	// self authored or "Any Employee" to select the author at the time the
	// form gets created
	if (subjectEmployeeChooseAuthor) {
		whoCanAdd = whoCanAdd + subjectEmployeeChooseAuthor;
	}
	return whoCanAdd;
};

export const checkDuplicateEasyAdd = (formObject, easyAddForms, index) => {
	const formToAddID = formObject.form.id || formObject.form._id;
	const formToAddWhoCanAdd = getWhoCanAdd(formObject.who_can_add_form, formObject.subject_employee_choose_author);

	for (let i = 0; i < easyAddForms.length; i++) {
		// only check for duplicates on forms that are not the one being
		// added/ updated
		if (index !== i) {
			const formID = easyAddForms[i].formID;

			const whoCanAdd = getWhoCanAdd(
				easyAddForms[i].who_can_add_form,
				easyAddForms[i].subject_employee_choose_author
			);
			if (formID === formToAddID && formToAddWhoCanAdd === whoCanAdd) {
				return true;
			}
		}
	}
	return false;
};
